// extracted by mini-css-extract-plugin
export default {"popupContainer":"popup_popupContainer__xJlna","loaderContainer":"popup_loaderContainer__Sg5K2"};